import { useSelector } from 'react-redux';

import { getUserOrGroup, isGroupContext } from '@/core/user';
import { RootState } from '@/store';
import {
  RateDisplayType,
  getRateDisplayTypeForLoggedIn,
  getRateDisplayTypeForLoggedOut,
} from '@/utils/rateDisplay';

export function useRateDisplay(): RateDisplayType {
  const viewer = useSelector((state: RootState) => state.viewer);
  const userContext = useSelector((state: RootState) => state.ui.userContext);

  if (viewer?.id) {
    // ENG-5504: follow the active view-as context's account, not a hardcoded
    // groups[0], and render its backend-provided display_currency. The groups[0]
    // fallback below also fires when the active context is a group not in
    // viewer.groups (stale/non-member context; tracked in ENG-5509) or one with no
    // billing_account. Fully hiding the rate in those cases isn't possible here (the
    // hook returns a non-optional RateDisplayType), so it's deferred to ENG-5509; F6
    // (RequestConsultation) enforces the stricter "never fall back to another group"
    // for the resolution CTA.
    const activeGroup = isGroupContext(userContext)
      ? getUserOrGroup(userContext, viewer)
      : undefined;
    const billingAccount = activeGroup?.billing_account ?? viewer?.groups?.[0]?.billing_account;
    return getRateDisplayTypeForLoggedIn(billingAccount);
  }
  return getRateDisplayTypeForLoggedOut();
}
